import { render } from "./ComponentNav.vue?vue&type=template&id=22786de1"
import script from "./ComponentNav.vue?vue&type=script&lang=js"
export * from "./ComponentNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__